import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import global from "./global";
import user from "./user";
// Import the streetReducer which combines streetLight and streetLightReport
import streetReducer from "views/user/StreetLight/Store/streetReducer";

// Redux Persist Configuration
const persistConfig = {
  key: "root",
  debug: false,
  storage,
};

// Combine all reducers into one
const rootReducers = combineReducers({
  global,
  user,
  street: streetReducer, // 'street' will now have 'streetLight' and 'streetLightReport'
});

// Create a root reducer to handle specific logic, if needed
const rootReducer = (state: any, action: any) => {
  return rootReducers(state, action);
};

// Wrap the root reducer with persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;
